import AxiosInterceptor from "../../AxiosInterceptorHearro";

// 메모 조회
// request data
//  - pid
//  - page
export function getMemoFromHearro(request) {
    return AxiosInterceptor({
        url: '/memo',
        method: 'get',
        params: request
    })
}


// 메모 작성
// request data
//  - pid
//  - memoInfo
export function postMemoToHearro(request) {
    return AxiosInterceptor({
        url: '/memo',
        method: 'post',
        data: request
    })
}